import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import GoogleAnalictics from "react-ga";
const useGoogleTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!window.location.href.includes("localhost")) {
      GoogleAnalictics.initialize("UA-201246679-1");
      setInitialized(true);
    }
  }, []);
  useEffect(() => {
    if (initialized) {
      GoogleAnalictics.pageview(location.pathname + location.search);
    }
  }, [initialized, location]);
};

export default useGoogleTracker;
